import { render, staticRenderFns } from "./payment-gateway-advam.vue?vue&type=template&id=18c8cb13&scoped=true"
import script from "./payment-gateway-advam.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-gateway-advam.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-gateway-advam.vue?vue&type=style&index=0&id=18c8cb13&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8cb13",
  null
  
)

export default component.exports